module.exports = __webpack_public_path__ + "img/sq4m_05.a13f3085.jpg";